import Service from './Service';
const SOURCE_TYPE = ['', 'HOMEWORK', 'COUPON', 'ARCHIVES', 'EVALUATION'];

class HomeWorkService {
  constructor(props) {
    this.PATH = {
      SAVE_HOMEWORK_SHARE: 'public/homework/sharingStudentDynamic',
      SAVE_HOMEWORK_SHARE_ANON: 'anon/homework/sharingStudentDynamic',
      HOMEWORK_SHARE_DETAIL: 'public/homework/getSharingDetail',
      HOMEWORK_SHARE_DETAIL_ANON: 'anon/homework/getSharingDetailVersionTwo',
      GET_ARCHIVES_SHARE_COMMENT: 'anno/esCommon/commentList',
      GET_LOOK_NUM: 'public/homework/getHomeworkLookCount',
      GET_LOOK_NUM_ANON: 'anon/homework/getHomeworkLookCount',
      SHARE_INST_DETAIL: 'anon/inst/getInstShareDetail',
      SHARE_LIKE: 'public/homework/likeStudentHomework',
      SHARE_LIKE_ANON: 'anon/homework/likeStudentHomework',
      GET_SHARE_EVALUATION: 'anno/studentAssess/detail',
      HOMEWORK_COMMENT_LIST: 'public/homework/getHomeworkCommentListForStu',
      HOMEWORK_COMMENT_LIST_ANON: 'anon/homework/getHomeworkCommentListForStu',
      HOMEWORK_VISITOR_DETAIL: 'anon/homework/getVisitorHomeworkAnswerDetail',
      GET_EXAM_REPORT: 'anon/homework/getStudentShareExamReport',
      SHARE_FLAG_SIGN: 'public/homework/shareById'
    };
    this.PageSize = 10;
  }

  /**
   * 记录用户的分享行为
   * @param {} shareId
   */
  shareFlagSignById(shareId) {
    const params = {
      shareId
    };
    return axios.Zeus(this.PATH.SHARE_FLAG_SIGN, params);
  }
  /**
   *
   * @returns {*|Array}
   */

  // 保存分享内容，获取分享Id
  saveShare(instId, studentId, backgroundPicture, title, graphicContent, associatedId, sourceType, userId = '', preSharingId = '', abstractInfo = '') {
    const params = {
      instId,
      studentId,
      backgroundPicture,
      title,
      graphicContent,
      associatedId,
      sourceType: isNaN(parseInt(sourceType)) ? sourceType : SOURCE_TYPE[parseInt(sourceType)],
      userId,
      preSharingId,
      abstractInfo
    };

    return axios.Zeus(this.PATH.SAVE_HOMEWORK_SHARE, params);
  }
  // 分享页-保存分享内容，获取分享Id
  saveShareAnon(instId, studentId, backgroundPicture, title, graphicContent, associatedId, sourceType, userId = '', preSharingId = '') {
    const params = {
      instId,
      studentId,
      backgroundPicture,
      title,
      graphicContent,
      associatedId,
      sourceType: isNaN(parseInt(sourceType)) ? sourceType : SOURCE_TYPE[parseInt(sourceType)],
      userId,
      preSharingId
    };

    return axios.Zeus(this.PATH.SAVE_HOMEWORK_SHARE_ANON, params);
  }



  handleShare(params) {
    return axios.Zeus(this.PATH.SAVE_HOMEWORK_SHARE, { ...params, sourceType: SOURCE_TYPE[parseInt(params.sourceType)] });
  }

  // 获取分享数据
  getShareData(shareId) {
    const params = {
      shareId
      // id: "956828494216560771"
    };

    return axios.Zeus(this.PATH.HOMEWORK_SHARE_DETAIL, params);
  }

  // 分享页-获取分享数据
  getShareDataAnon(shareId, applyType) {
    const params = {
      shareId,
      applyType
    };

    return axios.Zeus(this.PATH.HOMEWORK_SHARE_DETAIL_ANON, params);
  }

  // 获取成长档案互评列表
  getArchivesShareComment(docId) {
    const params = {
      docId
    };
    return axios.Zeus(this.PATH.GET_ARCHIVES_SHARE_COMMENT, params);
  }

  // 获取围观数
  getLookNum(shareId) {
    const params = {
      shareId
    };

    return axios.Zeus(this.PATH.GET_LOOK_NUM, params);
  }

  // 分享页-获取围观数
  getLookNumAnon(shareId) {
    const params = {
      shareId
    };

    return axios.Zeus(this.PATH.GET_LOOK_NUM_ANON, params);
  }


  // 获取机构信息
  getShareInstDetail(instId) {
    const params = {
      instId
    };
    return axios.Zeus(this.PATH.SHARE_INST_DETAIL, params);
  }

  // 点赞
  addShareLike(shareId, sourceType, openId) {
    const params = {
      shareId,
      sourceType: isNaN(parseInt(sourceType)) ? sourceType : SOURCE_TYPE[parseInt(sourceType)],
      openId
    };

    return axios.Zeus(this.PATH.SHARE_LIKE, params);
  }

  // 分享页-点赞
  addShareLikeAnon(shareId, sourceType, openId) {
    const params = {
      shareId,
      sourceType: isNaN(parseInt(sourceType)) ? sourceType : SOURCE_TYPE[parseInt(sourceType)],
      openId
    };

    return axios.Zeus(this.PATH.SHARE_LIKE_ANON, params);
  }

  // 获取课后点评互评列表
  getShareEvaluation(assessId) {
    const params = {
      assessId
    };
    return axios.Zeus(this.PATH.GET_SHARE_EVALUATION, params);
  }

  // 获取作业互评列表
  getHomeworkCommentList(answerId) {
    const params = {
      answerId
    };

    return axios.Zeus(this.PATH.HOMEWORK_COMMENT_LIST, params);
  }

  // 分享页-获取作业互评列表
  getHomeworkCommentListAnon(answerId) {
    const params = {
      answerId
    };

    return axios.Zeus(this.PATH.HOMEWORK_COMMENT_LIST_ANON, params);
  }


  // 获取作业要求
  getHomeworkVisitorDetail(answerId) {
    const params = {
      answerId
    };

    return axios.Zeus(this.PATH.HOMEWORK_VISITOR_DETAIL, params);
  }

  // 获取测评报告
  getExamReport(shareId) {
    const params = {
      shareId
    }

    return axios.Zeus(this.PATH.GET_EXAM_REPORT, params);
  }

};

export default new HomeWorkService();



// WEBPACK FOOTER //
// ./src/service/ShareService.js